/* border-t-1 py-2 lg:p-0 col-span-2 lg:col-auto flex justify-center items-center lg:col-span-3 lg:text-3xl float-left float-right */

const clickEvent = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) ? 'click':'click'
function checkCookieConsent() {
    if (Cookies.get('cookieconsent_dismissed') !== 'yes') {
        let cc = document.createElement('div')
        let a = document.createElement('a')
        a.appendChild(document.createTextNode('Got it!'))
        a.className = 'px-8 py-3 bg-purple hover:bg-pink text-white float-right'
        a.addEventListener(clickEvent, () => {
            Cookies.set('cookieconsent_dismissed', 'yes', { expires: 365 })
            document.getElementById('cookieConsent').remove()
        })
        cc.innerHTML = '<div id="cookieConsent" class="border-t fixed bottom-0 left-0 right-0 bg-white p-4" style="z-index: 999;"><div class="inline-block px-6 py-3">We uses cookies to ensure you get the best experience on our website. <a class="text-pink" href="/about/privacy-policy">More info <div class="sr-only">on our privacy policy</div></a></div></div>'
        cc = cc.children[0]
        cc.appendChild(a)
        document.body.append(cc)
    }
}
async function enableSearch(){
    const widgets = document.getElementsByClassName('site-search')
    let searchData = null
    if (widgets && widgets.length > 0) {
        let initializing = false
        function deburr(subjectString) { 
            'use strict';

            var reLatin1, deburredLetters,
                rsCombo, reComboMark;

            if (typeof subjectString !== 'string') {
                throw new TypeError('Expected a string');
            }

            // Used to match latin-1 supplementary letters (excluding mathematical operators).
            reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

            // Used to map latin-1 supplementary letters to basic latin letters.
            deburredLetters = {'\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A','\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a','\xc7': 'C', '\xe7': 'c','\xd0': 'D', '\xf0': 'd','\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E','\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e','\xcC': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I','\xeC': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i','\xd1': 'N', '\xf1': 'n','\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O','\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o','\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U','\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u','\xdd': 'Y', '\xfd': 'y', '\xff': 'y','\xc6': 'Ae', '\xe6': 'ae','\xde': 'Th', '\xfe': 'th','\xdf': 'ss'};

            // Used to compose unicode capture groups.
            rsCombo = ['\\u0300-\\u036f\\ufe20-\\ufe23', '\\u20d0-\\u20f0'];

            // Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
            // [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
            reComboMark = RegExp(rsCombo, 'g');

            return subjectString.replace(reLatin1, function deburrLetter(letter) {
                return deburredLetters[letter];
            }).replace(reComboMark, '');
        }
        const stopWords = {"": true,"a": true,"able": true,"about": true,"across": true,"after": true,"all": true,"almost": true,"also": true,"am": true,"among": true,"an": true,"and": true,"any": true,"are": true,"as": true,"at": true,"be": true,"because": true,"been": true,"but": true,"by": true,"can": true,"cannot": true,"could": true,"dear": true,"did": true,"do": true,"does": true,"either": true,"else": true,"ever": true,"every": true,"for": true,"from": true,"get": true,"got": true,"had": true,"has": true,"have": true,"he": true,"her": true,"hers": true,"him": true,"his": true,"how": true,"however": true,"i": true,"if": true,"in": true,"into": true,"is": true,"it": true,"its": true,"just": true,"least": true,"let": true,"like": true,"likely": true,"may": true,"me": true,"might": true,"most": true,"must": true,"my": true,"neither": true,"no": true,"nor": true,"not": true,"of": true,"off": true,"often": true,"on": true,"only": true,"or": true,"other": true,"our": true,"own": true,"rather": true,"said": true,"say": true,"says": true,"she": true,"should": true,"since": true,"so": true,"some": true,"than": true,"that": true,"the": true,"their": true,"them": true,"then": true,"there": true,"these": true,"they": true,"this": true,"tis": true,"to": true,"too": true,"twas": true,"us": true,"wants": true,"was": true,"we": true,"were": true,"what": true,"when": true,"where": true,"which": true,"while": true,"who": true,"whom": true,"why": true,"will": true,"with": true,"would": true,"yet": true,"you": true,"your": true}
        function tokenize (s) {
            let words = s ? deburr(s).toLowerCase().replace(/[^a-z0-9]/g, ' ').split(/\s+/) : []
            words = words.filter((word) => { return word.length > 1 && stopWords[word] !== true })
            for (let i = 0; i < words.length; i++) {
                words[i] = stemmer(words[i])
            }
            return words
        }
        const stemmer = (function () {
            var step2list = {"ational": "ate","tional": "tion","enci": "ence","anci": "ance","izer": "ize","bli": "ble","alli": "al","entli": "ent","eli": "e","ousli": "ous","ization": "ize","ation": "ate","ator": "ate","alism": "al","iveness": "ive","fulness": "ful","ousness": "ous","aliti": "al","iviti": "ive","biliti": "ble","logi": "log"},

                step3list = {"icate": "ic","ative": "","alize": "al","iciti": "ic","ical": "ic","ful": "","ness": ""},

                c = "[^aeiou]",          // consonant
                v = "[aeiouy]",          // vowel
                C = c + "[^aeiouy]*",    // consonant sequence
                V = v + "[aeiou]*",      // vowel sequence

                mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
                meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
                mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
                s_v = "^(" + C + ")?" + v;                   // vowel in stem

            var re_mgr0 = new RegExp(mgr0);
            var re_mgr1 = new RegExp(mgr1);
            var re_meq1 = new RegExp(meq1);
            var re_s_v = new RegExp(s_v);

            var re_1a = /^(.+?)(ss|i)es$/;
            var re2_1a = /^(.+?)([^s])s$/;
            var re_1b = /^(.+?)eed$/;
            var re2_1b = /^(.+?)(ed|ing)$/;
            var re_1b_2 = /.$/;
            var re2_1b_2 = /(at|bl|iz)$/;
            var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
            var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

            var re_1c = /^(.+?[^aeiou])y$/;
            var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

            var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

            var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
            var re2_4 = /^(.+?)(s|t)(ion)$/;

            var re_5 = /^(.+?)e$/;
            var re_5_1 = /ll$/;
            var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

            var porterStemmer = function porterStemmer(w) {
                var stem,
                    suffix,
                    firstch,
                    re,
                    re2,
                    re3,
                    re4;

                if (w.length < 3) { return w; }

                firstch = w.substr(0, 1);
                if (firstch == "y") {
                    w = firstch.toUpperCase() + w.substr(1);
                }

                // Step 1a
                re = re_1a
                re2 = re2_1a;

                if (re.test(w)) { w = w.replace(re, "$1$2"); }
                else if (re2.test(w)) { w = w.replace(re2, "$1$2"); }

                // Step 1b
                re = re_1b;
                re2 = re2_1b;
                if (re.test(w)) {
                    var fp = re.exec(w);
                    re = re_mgr0;
                    if (re.test(fp[1])) {
                        re = re_1b_2;
                        w = w.replace(re, "");
                    }
                } else if (re2.test(w)) {
                    var fp = re2.exec(w);
                    stem = fp[1];
                    re2 = re_s_v;
                    if (re2.test(stem)) {
                        w = stem;
                        re2 = re2_1b_2;
                        re3 = re3_1b_2;
                        re4 = re4_1b_2;
                        if (re2.test(w)) { w = w + "e"; }
                        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re, ""); }
                        else if (re4.test(w)) { w = w + "e"; }
                    }
                }

                // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
                re = re_1c;
                if (re.test(w)) {
                    var fp = re.exec(w);
                    stem = fp[1];
                    w = stem + "i";
                }

                // Step 2
                re = re_2;
                if (re.test(w)) {
                    var fp = re.exec(w);
                    stem = fp[1];
                    suffix = fp[2];
                    re = re_mgr0;
                    if (re.test(stem)) {
                        w = stem + step2list[suffix];
                    }
                }

                // Step 3
                re = re_3;
                if (re.test(w)) {
                    var fp = re.exec(w);
                    stem = fp[1];
                    suffix = fp[2];
                    re = re_mgr0;
                    if (re.test(stem)) {
                        w = stem + step3list[suffix];
                    }
                }

                // Step 4
                re = re_4;
                re2 = re2_4;
                if (re.test(w)) {
                    var fp = re.exec(w);
                    stem = fp[1];
                    re = re_mgr1;
                    if (re.test(stem)) {
                        w = stem;
                    }
                } else if (re2.test(w)) {
                    var fp = re2.exec(w);
                    stem = fp[1] + fp[2];
                    re2 = re_mgr1;
                    if (re2.test(stem)) {
                        w = stem;
                    }
                }

                // Step 5
                re = re_5;
                if (re.test(w)) {
                    var fp = re.exec(w);
                    stem = fp[1];
                    re = re_mgr1;
                    re2 = re_meq1;
                    re3 = re3_5;
                    if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
                        w = stem;
                    }
                }

                re = re_5_1;
                re2 = re_mgr1;
                if (re.test(w) && re2.test(w)) {
                    re = re_1b_2;
                    w = w.replace(re, "");
                }

                // and turn initial Y back to y

                if (firstch == "y") {
                    w = firstch.toLowerCase() + w.substr(1);
                }

                return w.replace('vacat', 'holiday').replace(/(mm|tt|ll|ss|cc|nn|aa|oo)/, (s) => s[0]);
            };

            return porterStemmer;
        })();
        function createSearchEngine() {
            let index = {
                data: [

                ],
                fields: {
                    t: { m: 5 },
                    p: { m: 2 },
                    d: { m: 1 },
                },
                search(q) {
                    const terms = tokenize(q)
                    let m = []
                    for (let i = 0; i < this.data.length; i++) {
                        let termScores = []
                        let s = 0
                        terms.forEach((term) => {
                            let termScore = { found: false }
                            Object.keys(this.fields).forEach(key => {
                                this.data[i].k[key].forEach((keyword) => {
                                    if (keyword.startsWith(term)) {
                                        s += this.fields[key].m
                                        termScore.found = true
                                    }
                                })
                            })
                            termScores.push(termScore)
                        })
                        // all tokens found
                        if (s > 0 && termScores.filter((term) => term.found).length == terms.length) {
                            m.push({
                                s: s,
                                d: this.data[i].d
                            })
                        }
                    }
                    const result = m.sort((a, b) => b.s - a.s)
                    return result
                }
            }
            searchData.forEach((doc) => {
                if(!(doc.p||'').startsWith('/pakistan')){
                    index.data.push({
                        d: doc,
                        k: {
                            t: tokenize(doc.t),
                            d: tokenize(doc.d),
                            p: tokenize(doc.p)
                        }
                    })
                }
            })
            return index
        }
        function setupSearchEngine() {
            if (!!searchData && !initializing) {
                initializing = true
                window.saSearch = `no search`
                const searchEngine = createSearchEngine()
                for (let i = 0; i < widgets.length; i++) {
                    window.createApp({
                        data: function () {
                            let q = document.location.search.match(/(\?|&)q=([^&]+)/)
                            if (q && q.length >= 2) {
                                q = decodeURIComponent(q[2])
                            } else {
                                q = ''
                            }
                            return {
                                open:false,
                                query: q
                            }
                        },
                        computed: {
                            searched(){
                                const _this = this
                                return sa.debounce((q)=>{
                                    _this.$refs.searchResults && _this.$refs.searchResults.scrollTo(0,0)
                                    sa.event('Search', 'query', q)
                                },800)
                            },
                            matches() {
                                const results = searchEngine.search(this.query)
                                window.saSearch = `query: ${this.query || 'EMPTY'} => ${results.length}`
                                this.searched(this.query)
                                return results
                            }
                        },
                        methods: {
                            resultClicked(p){
                                sa.event('Search', 'result_clicked', p)
                            },
                            toggleSearch(){
                                this.open = !this.open
                                const _this = this
                                if(this.open){
                                    setTimeout(()=>{_this.$refs.searchField.focus()},20)
                                }
                            },
                            windowkeydown(e) {
                                if (e.which == 27) {
                                    //
                                }
                            },
                            windowClicked(e) {
                                if (!this.$el.contains(e.target) || e.target.classList.contains('search-overlay')) {
                                    window.removeEventListener(clickEvent, this.windowClicked)
                                    //
                                }
                            }
                        }
                    }).mount(widgets[i])
                }
            }
        }
        const response = await fetch('/assets/searchIndex.json?ts='+(new Date()).toISOString().replace(/[^0-9]/g,'').slice(0,8), {
            method: 'GET',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json'},
        });
        if(response.status >= 200 && response.status < 400){
            searchData = await response.json()
            setupSearchEngine()
        }
    }
}
function adjustPhoneNumbers() {
    let n = null
    if (sa.phoneNumbers.hasOwnProperty(sa.info.country_code)) {
        n = sa.phoneNumbers[sa.info.country_code]
    } else {
        n = sa.phoneNumbers['default']
    }
    document.querySelectorAll('[data-phone-number]').forEach((el)=>{
        if (el.tagName == 'A') {
            el.href = 'tel:' + n.number.replace(/\s+/g, '')
        }
        el.innerHTML = n.formatted.replace(/\s+/g, '&nbsp;')
    })
}
function showMovingStill() {
    if (sa.info.device != 'desktop' || !sa.movingStill) {
        return
    }
    const playButton = document.querySelector('#banner-play-button')
    const pauseButton = document.querySelector('#banner-pause-button')
    const videoPlayer = document.createElement('video')
    videoPlayer.className = 'absolute inset-0 w-full h-full bg-black object-cover object-center opacity-0 transition-opacity duration-500'
    videoPlayer.autoplay = true
    videoPlayer.muted = true
    function addSource(srcInfo){
        if(srcInfo){
            const src = document.createElement('source')
            src.src = srcInfo.link_secure
            src.type = srcInfo.quality == 'hls' ? 'application/x-mpegURL' : srcInfo.type
            videoPlayer.appendChild(src)
        }
    }
    addSource(sa.movingStill.files.find((v)=>{
        return v.quality == 'hls'
    }))
    sa.movingStill.files.filter(f=>f.quality!='hls').sort((a,b)=>a.size>b.size?-1:1).forEach((fi)=>{
        addSource(fi)
    })
    const viewportWidth = document.body.getBoundingClientRect().width
    const sortedVideos = sa.movingStill.files.filter((v)=>{
        return v.quality != 'hls' && v.fps == 25 && v.width <= viewportWidth
    }).sort((a,b)=>{
        return a.size < b.size ? 1 : (a.size == b.size ? 0 : -1)
    })
    sortedVideos.length && addSource(sortedVideos[0])
    const bannerImage = document.querySelector('#banner .banner-image')
    // videoPlayer.poster = bannerImage.currentSrc
    const container = bannerImage.closest('.banner-container')
    container.appendChild(videoPlayer)
    const viewedVideos = JSON.parse(Cookies.get('viewedVideos') || '{}');
    const now = (new Date()).getTime();
    let loadstartedAt = null
    let autoplay = true
    if (typeof viewedVideos != 'object' || typeof viewedVideos.keys == "function") {
        viewedVideos = {};
    } else {
        if (viewedVideos.hasOwnProperty(sa.movingStill.uri)) {
            if ((now - viewedVideos[sa.movingStill.uri]) < 43200000) {
                autoplay = false
                pauseVideo()
            }
        }
    }
    try{
        if(autoplay){
            var playPromise = videoPlayer.play()
            if (playPromise !== undefined) {
                playPromise.then(_ => {
                // Automatic playback started!
                // Show playing UI.
                })
                .catch(error => {
                // Auto-play was prevented
                // Show paused UI.
                });
            }
        } 
    }catch(x){}
    bannerImage.addEventListener(clickEvent, playVideo, false)
    videoPlayer.addEventListener('loadstart', loadstart, {once:true})
    videoPlayer.addEventListener('loadeddata', loadeddata, {once:true})
    videoPlayer.addEventListener('timeupdate', playingVideo, false)
    playButton.addEventListener(clickEvent, playVideo)
    pauseButton.addEventListener(clickEvent, pauseVideo)
    function loadstart() {
        loadstartedAt = performance.now()
    }
    function playVideo() {
        var playPromise = videoPlayer.play()
        if (playPromise !== undefined) {
            playPromise.then(_ => {
                playButton.classList.add('hidden')
                pauseButton.classList.remove('hidden')
            })
            .catch(error => {
            });
        }
    }
    function loadeddata() {
        if ((performance.now() - loadstartedAt) > 3000) {
            pauseVideo()
        }
    }
    function pauseVideo() {
        if (bannerImage.complete && bannerImage.naturalHeight !== 0) {
            pauseButton.classList.add('hidden')
            playButton.classList.remove('hidden')
            videoPlayer.pause()
            videoPlayer.classList.add('opacity-0')
            setTimeout(() => { videoPlayer.classList.add('opacity-0') }, 0)
        } else {
            bannerImage.addEventListener("load", pauseVideo, true)
        }
    }
    function playingVideo() {
        videoPlayer.classList.remove('opacity-0')
        if (videoPlayer.currentTime > videoPlayer.duration / 2) {
            viewedVideos[sa.movingStill.uri] = now;
            Cookies.set('viewedVideos', JSON.stringify(viewedVideos), { expires: 7 });
        }
        if (videoPlayer.duration - videoPlayer.currentTime < 5) {
            videoPlayer.removeEventListener('timeupdate', playingVideo, false)
            setTimeout(function () {
                setTimeout(function () { pauseVideo() }, (videoPlayer.duration - videoPlayer.currentTime - 0.6) * 1000);
            }, 1000);
        }
    }
}

window.colors = {
    pink:'#e93189',
    pinkLink:'#e2187a',
	pinkHalf:'rgba(220,22,115,0.5)',
	littlegray:'rgba(89,89,89,0.5)',
    purple:'#712260',
    purpleHalf:'rgba(113,34,96,0.25)',
    text: '#111827',
}
const months = ['','january','february','march','april','may','june','july','august','september','october','november','december'];
const currentDestinations = []
let currentMonth = 1
function debounce(context, f, timeout = 250, leading = false, trailing = true) {
    let timer;
    return (...args) => {
        if (leading) {
            f.apply(context, args);
        }
        clearTimeout(timer);
        timer = window.setTimeout(() => {
            if (trailing) {
                f.apply(context, args);
            }
        }, timeout);
    };
}
function getFeatureLink(f){
    let countrySlug = f.properties.sa_destination_slug
    let countryWeather = f.properties.sa_weather
    if(!!document.location.pathname.match(/^\/[^\/]+-holidays\/weather/)){
        if(countryWeather == 'monthly'){
            return `/${countrySlug}-holidays/weather/${months[currentMonth]}`
        }else if(countryWeather == 'summary'){
            return `/${countrySlug}-holidays/weather`
        }
    }
    return `/${countrySlug}-holidays`
}
function drawJourney(map, route){
    const canvas = document.getElementById('journey-canvas')
    if(!canvas){
        return
    }
    paper.setup(canvas)
    const planePath = paper.project.importSVG('<svg version="1.1" id="icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"'
    + ' viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">'
    + ' <path id="plane" d="M100.7,177c-1.7,5.9-7.4,9.7-13.6,9.1l-9.9,0c-2.3,0.3-4.3-1.2-4.9-3.4c0-0.7,0.2-1.3,0.6-1.9'
    + ' c8.4-16.5,15.2-33.9,20.2-51.7c0.2-3.2,2.7-10.5,0.9-12.2c-1.9-1.6-54.3-9-54.3-9c-4.2,5.8-7.1,12.3-8.7,19.2'
    + ' c-0.3,3.5-3,6.3-6.5,6.5c-4.5-0.4-15,0.2-14.7-4.7s6.1-16.6,6-20.5c-0.1-3.9-6.9-4.4-10.8-6.1l0-5.1c3.8-1.6,10.8-1.7,10.8-6.1'
    + ' s-5.9-14.7-6-20.5c-0.1-5.7,10.3-4.2,14.7-4.7c3.5,0.2,6.3,3,6.6,6.6c1.6,6.9,4.5,13.5,8.7,19.2c0,0,51.3-7.8,54.3-9'
    + ' c3.1-1.1-0.5-9.3-0.9-12.2c-5-17.8-11.8-35.2-20.2-51.7c-0.4-0.6-0.6-1.2-0.6-1.9c0.6-2.2,2.6-3.6,4.9-3.4l9.9,0.1'
    + ' c6.1-0.6,11.8,3.2,13.6,9.1l28.1,56.5c1.6,2.2,3.5,4.1,5.7,5.7c5.7,1.2,11.5,1.9,17.3,2.1c0,0,28.5,1.9,31.5,2.6'
    + ' c8,1.9,11.6,3.8,11.7,11c0.1,7.2-3.6,9.1-11.6,11.1c-2.9,0.6-31.5,2.6-31.5,2.6c-5.8,0-11.6,0.7-17.3,2.1c-2.2,1.6-4.1,3.5-5.7,5.7'
    + ' L100.7,177z"/>'
    + ' </svg>');
    const planeSymbol = new paper.Symbol(planePath)
    planePath.fillColor = colors.pink;

    var doPath = function () {
        paper.project.clear();
        var path = new paper.Path();
        path.strokeColor = 'RGB(115, 35, 87)';
        const cleanRoute = []
        let tx = null
        for(let i = 0; i < route.length; i++){
            if(route[i].t == 'r'){
                route[i].tx = tx
                tx = null
                if(route[i].hasOwnProperty('c') && route[i].c){
                    cleanRoute.push(route[i])
                }
            }else if(route[i].t == 't'){
                tx = route[i].v
            }
        }
        route = cleanRoute
        var start = new paper.Point(map.project([route[0].c[1],route[0].c[0]]));
        path.moveTo(start);
        for (var i = 1; i < route.length; i++) {
            path.lineTo(map.project([route[i].c[1],route[i].c[0]]));
        }
        path.smooth({ type: 'catmull-rom' });
        for (var i = 0; i < path.curves.length; i++) {
            if (i <= route.length - 3 && route[i].c[0] == route[i + 2].c[0] && route[i].c[1] == route[i + 2].c[1]) {
                var x = new paper.Path([path.segments[i], path.segments[i + 1]]) // i+1 works as we're working on curves...
                x.strokeColor = colors.purple;
                x.strokeWidth= 2
                if (path.curves[i].length > 100) {
                    var shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.60), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.60).angle + 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                    shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.40), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.40).angle - 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                }else if (path.curves[i].length > 60) {
                    var shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.55), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.55).angle + 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                    shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.45), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.45).angle - 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                }
                i++
            } else if (i <= route.length - 2 && route[i].c[0] == route[i + 1].c[0] && route[i].c[1] == route[i + 1].c[1]) {
                //var x = new paper.Path([path.segments[i], path.segments[i + 1]]) // i+1 works as we're working on curves...
                //x.strokeColor = 'red';
                // x.strokeWidth= 2
            } else if (i <= route.length - 2 && route[i+1].tx == 'f') {
                var x = new paper.Path([path.segments[i], path.segments[i + 1]]) // i+1 works as we're working on curves...
                x.strokeColor = colors.purple;
                x.strokeWidth= 2
                x.dashArray = [5, 2.5];
                if (path.curves[i].length > 200) {
                    planeSymbol.place(path.curves[i].getPointAtTime(0.33)).rotate(path.curves[i].getTangentAtTime(0.33).angle).scale(0.1);
                    planeSymbol.place(path.curves[i].getPointAtTime(0.66)).rotate(path.curves[i].getTangentAtTime(0.66).angle).scale(0.1);
                }else if (path.curves[i].length > 100) {
                    planeSymbol.place(path.curves[i].getPointAtTime(0.5)).rotate(path.curves[i].getTangentAtTime(0.5).angle).scale(0.1);
                }
            } else {
                var x = new paper.Path([path.segments[i], path.segments[i + 1]]) // i+1 works as we're working on curves...
                x.strokeColor = colors.purple;
                x.strokeWidth= 2
                if (path.curves[i].length > 300) {
                    var shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.33), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.33).angle + 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                    shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.66), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.66).angle + 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                }else if (path.curves[i].length > 100) {
                    var shape = new paper.Path.RegularPolygon(path.curves[i].getPointAtTime(0.5), 3, 8);
                    shape.rotate(path.curves[i].getTangentAtTime(0.5).angle + 90, shape.bounds.bottomCenter.add(0, -shape.bounds.height / 3));
                    shape.fillColor = colors.pink;
                }
            }
        }
        path.remove();
        paper.view.draw();
    }
    doPath()
    const bounds = map.getBounds()
    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()
    map.addSource('route', {
        'type': 'canvas',
        canvas: 'journey-canvas',
        coordinates:[
            [sw.lng, ne.lat],
            [ne.lng, ne.lat],
            [ne.lng, sw.lat],
            [sw.lng, sw.lat],
        ],
        animate:true
    });
    map.addLayer({
        'id': 'route',
        type: 'raster',
        source: 'route'
    }, 'settlement-major-label');
}
function createMapDrawer(){
    document.querySelectorAll('[data-mapwrap]').forEach((mapWrapElement)=>{
        const mapClose = document.querySelector('.'+mapWrapElement.dataset.mapwrap)
        let title = document.querySelector('.main-text h3')
        if(title){
            title.after(mapWrapElement)
        }else{
            title = document.querySelector('.main-text h2')
            if(title){
                title.after(mapWrapElement)
            }else{
                title = document.querySelector('.main-text h1')
                if(title){
                    title.after(mapWrapElement)
                }
            }
        }
        mapWrapElement.classList.remove('hidden')
        const mapwrapClickHandler = ()=>{
            const mapwrap = document.querySelector('#'+mapWrapElement.dataset.mapwrap)
            if(mapwrap.classList.contains('sm:mt-[-56.25%]')){
                mapwrap.classList.remove('sm:mt-[-56.25%]')
                mapwrap.classList.remove('mt-[-100%]')
                setTimeout(()=>{mapClose.classList.remove('hidden')},200)
            }else{
                mapwrap.classList.add('sm:mt-[-56.25%]')
                mapwrap.classList.add('mt-[-100%]')
                mapClose.classList.add('hidden')
            }
        }
        mapWrapElement.addEventListener(clickEvent, mapwrapClickHandler)
        mapClose.addEventListener(clickEvent, mapwrapClickHandler)
    })
}
function showLocation(mapData, map){
    createMapDrawer()
    map.addSource('that-location', {
        'type': 'geojson',
        data: {
            "type": "FeatureCollection",
            "features": [{
                "type": "Feature",
                "geometry": {"type": "Point","coordinates": [mapData.location.coordinates.lng,mapData.location.coordinates.lat]},
                "properties": {"name":mapData.location.name}
            }]
        }});
    map.addLayer({
        'id': 'that-location',
        'type': 'circle',
        'source': 'that-location',
        'paint': {
            'circle-color': colors.pink,
            'circle-radius': 6,
            'circle-stroke-color': colors.purple,
            'circle-stroke-width': 2
        }
    })
    new mapboxgl.Popup({closeButton:false, className:'text-xl font-title p-4 text-center', closeOnClick:false, maxWidth:'320px'})
        .setLngLat([mapData.location.coordinates.lng,mapData.location.coordinates.lat])
        .setText(mapData.location.name)
        .addTo(map)

    map.setCenter(mapData.location.coordinates)
    map.setZoom(mapData.location.zoom+1)
}
function showJourney(mapData, map){
    const routePoints = mapData.route.filter((f)=>f.hasOwnProperty('c')&&f.c).map((c)=>[c.c[1],c.c[0]])
    if(!routePoints.length){
        return false
    }
    createMapDrawer()
    map.on('moveend', (e) => {
        if(e.firstFit === true){
            map.setLayoutProperty('settlement-major-label', 'visibility', 'none');
            map.setLayoutProperty('settlement-major-label', 'visibility', 'none');
            drawJourney(map, mapData.route)            
        }
    });
    let bounds = null
    for (const f of routePoints) {
        if(bounds){
            bounds.extend(f)
        }else{
            bounds = new mapboxgl.LngLatBounds(f,f)
        }          
    }
    const data = mapData.route.filter((f)=>f.hasOwnProperty('c')&&f.c).map(function(f){
        return {
            "type": "Feature",
            "geometry": {"type": "Point","coordinates": [f.c[1],f.c[0]]},
            "properties": {"name":f.n}
        }
    })  
    map.addSource('journey-places', {
        'type': 'geojson',
        data: {
            "type": "FeatureCollection",
            "features": data.filter((value, index, self)=>self.findIndex((v)=>value.properties.name == v.properties.name) === index)
        }
    });
    const routeStart = data[0]
    map.addSource('journey-start', {
        'type': 'geojson',
        data: {
            "type": "FeatureCollection",
            "features": [routeStart]
        }
    });
    map.addLayer({
        'id': 'journey-start',
        'type': 'circle',
        'source': 'journey-start',
        'paint': {
            'circle-color': colors.pink,
            'circle-radius': 6,
            'circle-stroke-color': colors.purple,
            'circle-stroke-width': 2
        }
    })
    if(data.length>1){
        const routeEnd = data[data.length-1]
        if(routeStart.geometry.coordinates[0] != routeEnd.geometry.coordinates[0]
            && routeStart.geometry.coordinates[1] != routeEnd.geometry.coordinates[1]){
            map.addSource('journey-end', {
                'type': 'geojson',
                data: {
                    "type": "FeatureCollection",
                    "features": [routeEnd]
                }
            });
            map.addLayer({
                'id': 'journey-end',
                'type': 'circle',
                'source': 'journey-end',
                'paint': {
                    'circle-color': colors.purple,
                    'circle-radius': 6,
                    'circle-stroke-color': colors.purple,
                    'circle-stroke-width': 2
                }
            })
        }
    }
    if(sa.info.device != 'phone'){
        map.addLayer({
            'id': 'journey-places-labels',
            'name': 'journey-places-labels',
            'type': 'symbol',
            'source': 'journey-places',
            'layout': {
                "icon-image":"dot-11",
                "text-anchor":"bottom",
                "text-field": ["get", "name"],
                "text-offset": [0,-0.5],
                "text-size": 18,
                "text-line-height": 1.1,
                "text-max-width": 6,
                "text-allow-overlap":true,
                "icon-allow-overlap":true,
                "icon-ignore-placement":true,
                "text-variable-anchor":["bottom", "top","right", "left"],
                "text-font":[
                    "Source Serif Pro Bold"
                ],
            },
            'paint': {
                "text-color": "black",
                "text-halo-color": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    2,
                    "hsla(35, 19%, 100%, 0.75)",
                    3,
                    "hsl(35, 19%, 100%)"
                ],
                "text-halo-width": 1
            }
        },'settlement-major-label')
    }
    if(bounds){
        map.fitBounds(bounds, {
            padding: sa.info.device != 'phone' ? {top: 80, bottom:50, left: 50, right: 50} : 20,
            duration:0
        },{firstFit:true})
    }
}
function transformPlaces(mapData, map){
    let selecta = document.getElementById('places-selecta')
    let title = document.querySelector('.main-text h3')
    if(title){
        title.after(selecta)
    }else{
        title = document.querySelector('.main-text h2')
        if(title){
            title.after(selecta)
        }else{
            title = document.querySelector('.main-text h1')
            if(title){
                title.after(selecta)
            }
        }
    }
    if(title){
        selecta.classList.remove('hidden')
    }
    
    const data = mapData.markers.filter((f)=>f.hasOwnProperty('coordinates')&&f.coordinates).map(function(f){
        return {
            "type": "Feature",
            "geometry": {"type": "Point","coordinates": [f.coordinates.lng,f.coordinates.lat]},
            "properties": {"slug": f.slug,"name":f.name},
            "id": f.id
        }
    })  
    map.addSource('sa-places', {'type': 'geojson',data: {"type": "FeatureCollection","features": data}});
    const placesLabels = {
        'id': 'sa-places-labels',
        'type': 'symbol',
        'source': 'sa-places',
        'layout': {
            // "icon-image":"dot-11",
            // "icon-size":2,
            // "icon-allow-overlap":true,
            // "icon-ignore-placement":true,
            // "text-anchor":"bottom",
            "text-field": ["get", "name"],
            "text-offset": [0,-0.5],
            "text-size": 18,
            "text-line-height": 1.1,
            "text-max-width": 6,
            "text-allow-overlap":true,
            "text-variable-anchor":["bottom", "top","right", "left"],
            "text-font":[
                "Source Serif Pro Bold"
            ],
        },
        'paint': {
            "text-color": ["case",["boolean", ["feature-state", "hover"], false],colors.purple, colors.pinkLink],
            "text-halo-color": [
                "interpolate",
                ["linear"],
                ["zoom"],
                2,
                "hsla(35, 19%, 100%, 0.75)",
                3,
                "hsl(35, 19%, 1.0)"
            ],
            "text-halo-width": 1
        }
    }
    if(mapData.iso){
        map.addLayer(
            {
            id: 'country-boundaries',
            source: {
                type: 'vector',
                url: 'mapbox://mapbox.country-boundaries-v1',
            },
            'source-layer': 'country_boundaries',
            type: 'line',
            paint: {'line-color': colors.purpleHalf},
            },
            'country-label'
        );
        map.setFilter('country-boundaries', ["in","iso_3166_1",mapData.iso]);
    }
    if(mapData.current && mapData.current.id){
        placesLabels.filter = ['!=', 'id', mapData.current.id]
        map.addLayer({
            'id': 'sa-current-place-label',
            'type': 'symbol',
            'source': 'sa-places',
            'filter':['==', 'id', mapData.current.id],
            'layout': {
                // "icon-image":"dot-11",
                // "icon-size":2,
                // "icon-allow-overlap":true,
                // "icon-ignore-placement":true,
                // "text-anchor":"bottom",
                "text-field": ["get", "name"],
                "text-offset": [0,-0.5],
                "text-allow-overlap":true,
                "text-size": 20,
                "text-line-height": 1.1,
                "text-max-width": 6,
                "text-variable-anchor":["bottom", "top","right", "left"],
                "text-font":["Source Serif Pro Bold"],
            },
            'paint': {
                "text-color": colors.pink,
                "text-halo-color": ["interpolate",["linear"],["zoom"],2,"hsla(35, 19%, 100%, 0.75)",3,"hsl(35, 19%, 100%)"],
                "text-halo-width": 1
            }
        });
    }
    map.addLayer(placesLabels);
    map.on(clickEvent, function(e) {
        const features = map.queryRenderedFeatures(e.point, { layers: ['sa-places-labels'] });
        if(features.length){
            document.location.assign(document.location.pathname.replace(/\/travel-guides(\/?.*)/, '/travel-guides') +'/'+ features[0].properties.slug)
        }
    })
    let featureID = null;
    map.on('mouseleave', 'sa-places-labels', () => {
        if (featureID) {
            map.setFeatureState({source: 'sa-places',id: featureID},{hover: false});
        }
        featureID = null;
        map.getCanvas().style.cursor = '';
    })
    map.on('mousemove', 'sa-places-labels', (event) => {
        map.getCanvas().style.cursor = 'pointer';
        if (featureID) {
            map.removeFeatureState({source: 'sa-places',id: featureID});
        }
        featureID = event.features[0].id;
        map.setFeatureState({source: 'sa-places',id: featureID},{hover: true});
    })
    let bounds = null
    for (const f of data) {
        if(bounds){
            bounds.extend(f.geometry.coordinates)
        }else{
            bounds = new mapboxgl.LngLatBounds(f.geometry.coordinates,f.geometry.coordinates)
        }          
    }
    if(bounds){
        map.fitBounds(bounds, {padding: {top: 120, bottom:50, left: 50, right: 50},duration:0})
    }
}
async function weatherizeMap(mapContainer, map){
    currentMonth = mapContainer.dataset.month ? months.indexOf(mapContainer.dataset.month) : 1
    const d = await Promise.all([fetch('/data/weather-ratings'),fetch('/data/weather-summaries')])
    let ratingsData = await d[0].json()
    let summariesDataRaw = await d[1].json()
    let summariesData = [null]
    for(let i = 1; i < months.length; i++){
        let month = months[i].toLowerCase()
        summariesData[i] = {
            "best":summariesDataRaw.filter((s)=>s.slug == month && s.rating == 'best').sort((a,b)=>a.parent_name.localeCompare(b.parent_name)),
            "good":summariesDataRaw.filter((s)=>s.slug == month && s.rating == 'good').sort((a,b)=>a.parent_name.localeCompare(b.parent_name)),
            "mixed":summariesDataRaw.filter((s)=>s.slug == month && s.rating == 'mixed').sort((a,b)=>a.parent_name.localeCompare(b.parent_name)),
            "poor":summariesDataRaw.filter((s)=>s.slug == month && s.rating == 'poor').sort((a,b)=>a.parent_name.localeCompare(b.parent_name))
        }
    }
    ratingsData = ratingsData.map(function(f){
        return {
            "type": "Feature",
            "geometry": {"type": "Point","coordinates": [f[4],f[3]]},
            "properties": {"m": Number(f[1]),"r": f[2],"s":f[0]}
        }
    })
    map.addSource('sa-weather', {
        'type': 'geojson',
        data: {
            "type": "FeatureCollection",
            "features": ratingsData
        }
    });

    map.addLayer({
        'id': 'sa-weather-icons',
        'type': 'circle',
        'source': 'sa-weather',
        'paint': {
            'circle-blur': ['interpolate',['linear'],['zoom'],3,0.5,10,0.2],
            'circle-color': ['interpolate',['linear'],['get', 'r'],0,'#FF4022',1,'#cc752a',2,'#cc752a',3,'#98bf36',4,'#19954d',],
            'circle-opacity': 1,
            'circle-radius': ['interpolate',['linear'],['zoom'],3,10,10,50]
        }
    },'settlement-minor-label')
    function filterWeather(map, month, destinations, go, updateSummaries) {
        let filter = ['==', 'm', month]
        // if(destinations.length){
            // filter = ["all",filter,['in', 's', ...destinations]]
        // }
        map.setFilter('sa-weather-icons', filter)
        document.querySelectorAll('#month-slider [data-month]').forEach((el)=>{el.classList.remove('text-pink','scale-150');})
        document.querySelector('#month-slider [data-month="'+month+'"]').classList.add('text-pink','scale-150')
        if(updateSummaries){
            const template = document.querySelector('#weather-summary-item')
            document.querySelectorAll('.weather-summary-section-item').forEach((s)=>{
                s.remove()
            })
            for(let key in summariesData[currentMonth]){
                const section = document.querySelector('.weather-summary-section-list[data-rating="'+key+'"]')
                const sectionTitle = document.querySelector('.weather-summary-section-title[data-rating="'+key+'"]')
                if(summariesData[currentMonth][key].length){
                    sectionTitle.classList.remove('hidden')
                }else{
                    sectionTitle.classList.add('hidden')
                }
                for(let i = 0; i < summariesData[currentMonth][key].length; i++){
                    const el = template.content.cloneNode(true)
                    el.querySelector('.weather-summary-title').innerHTML = summariesData[currentMonth][key][i].parent_name
                    el.querySelector('.weather-summary').innerHTML = summariesData[currentMonth][key][i].short_2 || summariesData[currentMonth][key][i].intro
                    el.querySelector('.weather-summary-link').href = '/'+summariesData[currentMonth][key][i].parent_name.toLowerCase().replace(' ','-')+'-holidays/weather/'+months[currentMonth]
                    section.appendChild(el)
                }
            }
            const capMonth = months[currentMonth][0].toUpperCase()+months[currentMonth].slice(1)
            document.querySelectorAll('.weather-summary-month').forEach((s)=>{
                s.innerHTML = capMonth
            })
            if('history' in window){
                history.pushState({},'',document.location.pathname.replace(/\/[^/]+$/,'/'+months[currentMonth]))
                setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
            }
        }
        if(go){
            let bounds = null
            for (const f of ratingsData) {
                if(f.properties.m == month && (destinations.length == 0 || destinations.indexOf(f.properties.s) >=0 )){
                    if(bounds){
                        bounds.extend(f.geometry.coordinates)
                    }else{
                        bounds = new mapboxgl.LngLatBounds(
                            f.geometry.coordinates,
                            f.geometry.coordinates
                        )
                    }
                }                
            }
            if(bounds){
                setTimeout(()=>{

                map.fitBounds(bounds, {
                    padding: destinations.length ? 50 : 20,
                    duration:0
                })
                },2000)
            }
        }
    }
    filterWeather(map, currentMonth, currentDestinations, true, false)
    // months toggle
    document.querySelectorAll('#month-slider [data-month]').forEach((el)=>{
        el.addEventListener(clickEvent, (e) => {
            currentMonth = parseInt(el.dataset.month)                
            filterWeather(map, currentMonth, currentDestinations, false, true)
        })
    })
    // destinations toggle
    document.querySelectorAll('.destinations-dropdown [data-destination]').forEach((el)=>{
        el.addEventListener(clickEvent, (e) => {
            e.preventDefault()
            const destination = el.dataset.destination
            const ix = currentDestinations.indexOf(destination)
            if(ix >= 0){
                currentDestinations.splice(ix, 1)
                el.classList.remove(['text-pink','scale-150'])
            }else{
                currentDestinations.splice(0, currentDestinations.length, destination)
                el.classList.add(['text-pink','scale-150'])                    
            }
            filterWeather(map, currentMonth, currentDestinations, true, false)
            return false
        })
    })
}
function showDestinations(map){
    map.setFilter('country-label', [
        "all",
            [
                "match",
                    ["get", "class"],
                    ["country","disputed_country"],
                    [
                        "match",
                            ["get", "worldview"],
                            ["all", "US"],true,
                            false
                    ],
                    false
            ],
            [
                "match",
                    ["get", "iso_3166_1"],
                    ["KH","BT","VN","LK","IN","ID","JP","MY","MV","MM","NP","KR","TH","LA","SG","HK"],false,
                    true
            ]
    ])
    map.addSource('sa-destinations', {
        'type': 'geojson',
        'data': {
        "features": [
            {
                type: "Feature",id:264, 
                properties: {sa_destination_name: "Laos",sa_destination_slug: "laos",sa_weather: "monthly"},
                geometry: {coordinates: [102.609699,19.924744],type: "Point"},
            },
            {
                type: "Feature",id:250, 
                properties: {sa_destination_name: "Sri Lanka",sa_destination_slug: "sri-lanka",sa_weather: "monthly"},
                geometry: {coordinates: [80.679999,7.572808],type: "Point"},
            },
            {
                type: "Feature",id:253, 
                properties: {sa_destination_name: "Indonesia",sa_destination_slug: "indonesia",sa_weather: "monthly"},
                geometry: {coordinates: [117.366317,-2.331145],type: "Point"},
            },
            {
                type: "Feature",id:251, 
                properties: {sa_destination_name: "Borneo",sa_destination_slug: "borneo",sa_weather: "monthly"},
                geometry: {coordinates: [113.313626,2.72133],type: "Point"},
            },
            {
                type: "Feature",id:263, 
                properties: {sa_destination_name: "Tibet",sa_destination_slug: "tibet",sa_weather: "monthly"},
                geometry: {coordinates: [88.039798,31.528517],type: "Point"},
            },
            {
                type: "Feature",id:256, 
                properties: {sa_destination_name: "Maldives",sa_destination_slug: "maldives",sa_weather: "summary"},
                geometry: {coordinates: [73.287346,3.211012],type: "Point"},
            },
            {
                type: "Feature",id:254, 
                properties: {sa_destination_name: "Japan",sa_destination_slug: "japan",sa_weather: "monthly"},
                geometry: {coordinates: [138.728176,36.416989],type: "Point"},
            },
            {
                type: "Feature",id:252, 
                properties: {sa_destination_name: "India",sa_destination_slug: "india",sa_weather: "monthly"},
                geometry: {coordinates: [78.513628,22.196365],type: "Point"},
            },
            {
                type: "Feature",id:247, 
                properties: {sa_destination_name: "Cambodia",sa_destination_slug: "cambodia",sa_weather: "monthly"},
                geometry: {coordinates: [104.930313,12.438102],type: "Point"},
            },
            {
                type: "Feature",id:898, 
                properties: {sa_destination_name: "Singapore",sa_destination_slug: "singapore",sa_weather: null},
                geometry: {coordinates: [103.810349,1.320415],type: "Point"},
            },
            {
                type: "Feature",id:899, 
                properties: {sa_destination_name: "Hong Kong",sa_destination_slug: "hong-kong",sa_weather: null},
                geometry: {coordinates: [114.167137,22.259731],type: "Point"},
            },
            {
                type: "Feature",id:249, 
                properties: {sa_destination_name: "Vietnam",sa_destination_slug: "vietnam",sa_weather: "monthly"},
                geometry: {coordinates: [108.34049,14.265776],type: "Point"},
            },
            {
                type: "Feature",id:248, 
                properties: {sa_destination_name: "Bhutan",sa_destination_slug: "bhutan",sa_weather: "monthly"},
                geometry: {coordinates: [90.445455,27.437648],type: "Point"},
            },
            {
                type: "Feature",id:260, 
                properties: {sa_destination_name: "South Korea",sa_destination_slug: "south-korea",sa_weather: "monthly"},
                geometry: {coordinates: [128.197995,36.528774],type: "Point"},
            },
            {
                type: "Feature",id:258, 
                properties: {sa_destination_name: "Nepal",sa_destination_slug: "nepal",sa_weather: "monthly"},
                geometry: {coordinates: [84.025878,28.261355],type: "Point"},
            },
            {
                type: "Feature",id:257, 
                properties: {sa_destination_name: "Myanmar",sa_destination_slug: "myanmar",sa_weather: "monthly"},
                geometry: {coordinates: [96.488007,21.288064],type: "Point"},
            },
            {
                type: "Feature",id:262, 
                properties: {sa_destination_name: "Thailand",sa_destination_slug: "thailand",sa_weather: "monthly"},
                geometry: {coordinates: [101.028101,15.136018],type: "Point"},
            },
            {
                type: "Feature",id:255, 
                properties: {sa_destination_name: "Malaysia",sa_destination_slug: "malaysia",sa_weather: "monthly"},
                geometry: {coordinates: [102.290462,4.486822],type: "Point"},
            }
        ],
        "type": "FeatureCollection"
        }
    });
    map.addLayer({
        'id': 'sa-destinations',
        'type': 'symbol',
        'source': 'sa-destinations',
        "minzoom": 2,
        "maxzoom": 9,
        'layout': {
            "text-field": ["get", "sa_destination_name"],
            "text-size": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    2,
                    12,
                    10,
                    32
                ],
            "text-justify": "auto",
            "text-allow-overlap":true,
            "text-ignore-placement":true,
            "text-line-height": 1.1,
            "text-max-width": 6,
            "text-font":[
                "Source Serif Pro Bold"
            ],
        },
        'paint': {
            "text-color": ["case",["boolean", ["feature-state", "hover"], false],colors.pink,colors.text],
            "text-halo-color": "#ffffff",
            "text-halo-width": 2
        }
    });
    map.on(clickEvent, function(e) {
        const features = map.queryRenderedFeatures(e.point, { layers: ['sa-destinations'] });
        if(features.length){
            const targetPath = getFeatureLink(features[0])
            if(targetPath){
                document.location.pathname = targetPath
            }
        }
    })

    let featureID = null;
    map.on('mouseleave', 'sa-destinations', () => {
        map.getCanvas().style.cursor = '';
        if (featureID) {
            map.setFeatureState({source: 'sa-destinations',id: featureID},{hover: false});
        }
        featureID = null;
        map.getCanvas().style.cursor = '';
    })
    map.on('mousemove', 'sa-destinations', (event) => {
        map.getCanvas().style.cursor = 'pointer';
        if (featureID) {
            map.removeFeatureState({source: 'sa-destinations',id: featureID});
        }
        featureID = event.features[0].id;
        map.setFeatureState({source: 'sa-destinations',id: featureID},{hover: true});
    })
}
window.doMap = async(mapData)=>{
    const mapContainer = mapData.container || document.querySelector(mapData.id)
    if(!mapContainer){
        return
    }
    mapContainer.classList.add('opacity-0','transition-all','duration-300')
    const map = new mapboxgl.Map({container: mapContainer,style: 'mapbox://styles/vratier/cldedsh6u000d01nvi3z1oif9',center: [111.56536970311117, 19.062529737912016],zoom: 3,
        // scrollZoom:false,boxZoom:false,dragRotate:false,dragPan:false,keyboard:false,doubleClickZoom:false,touchZoomRotate:false,
        cooperativeGestures: true
    })
    map.addControl(new mapboxgl.NavigationControl({showCompass:false}));
    map.addControl(new mapboxgl.FullscreenControl());
    map.addControl(new mapboxgl.ScaleControl({maxWidth: 80,unit: 'imperial'}));
    map.on('load', async () => {
        showDestinations(map)
        if(mapData.type == 'weather'){
            await weatherizeMap(mapContainer, map)
        }else if(mapData.type == 'places'){
            transformPlaces(mapData, map)
        }else if(mapData.type == 'journey'){
            showJourney(mapData, map)
        }else if(mapData.type == 'location'){
            showLocation(mapData, map)
        }
        setTimeout(()=>{mapContainer.classList.remove('opacity-0')})
    });
}
let settingThingsUp = false
window.setup = ()=>{
    console.warn('Setup...')
    if(settingThingsUp){
        console.debug('already setting up!')
        return
    }
    if(!window.createApp || !window.Swiper){
        if(performance.now() < 2000 ) {
            setTimeout(setup,500)
            console.warn('delayed')
            return
        }
    }
    settingThingsUp = true
    if(localStorage.getItem('sa_data')){
        document.body.classList.add('signed-in')
    }
    console.warn('proceeding')
    console.warn('check cookies')
    // checkCookieConsent()
    console.warn('country?')
    document.body.dataset.country_code = sa.info.country_code
    function updateOpeningTimes(){
        const now = new Date()
        const day = now.getDay()
        const hour = now.getHours()
        let schedule = [
            false,
            {start:9,end:17},
            {start:9,end:17},
            {start:9,end:17},
            {start:9,end:17},
            {start:9,end:17},
            false,
        ]
        // Update for bank holidays remember to update Quattro responder
        // schedule = [
        //     false,              // Sunday
        //     false,              // Monday
        //     {start:9,end:17},   // Tuesday
        //     {start:9,end:17},   // Wednesday
        //     {start:9,end:17},   // Thursday
        //     {start:9,end:15},   // Friday
        //     false,              // Saturday
        // ]
        const todaysSchedule = schedule[day]
        let openingTimes = 'closed'
        if(todaysSchedule && hour<todaysSchedule.start){
            let time = todaysSchedule.start
            if(time<12){
                time = time+'am'
            }else if(time==12){
                time = '12pm'
            }else{
                time = (time-12)+'pm'
            }
            openingTimes = `closed until<br/>${time} UK time`
        }else if(todaysSchedule && todaysSchedule.start<=hour && todaysSchedule.end>hour){
            let time = todaysSchedule.end
            if(time<12){
                time = time+'am'
            }else if(time==12){
                time = '12pm'
            }else{
                time = (time-12)+'pm'
            }
            openingTimes = `open until<br/>${time} UK time`
        }else{
            let nextSchedule = null
            let dayIndex = day
            let i = 0
            do{
                dayIndex = (dayIndex + 1)%7
                nextSchedule = schedule[dayIndex]
            }while(!nextSchedule && i++<7)
            let time = nextSchedule.start
            if(time<12){
                time = time+'am'
            }else if(time==12){
                time = '12pm'
            }else{
                time = (time-12)+'pm'
            }
            let nextDay = dayIndex == ((day+1)%7) ? 'tomorrow' : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][dayIndex]
            openingTimes = `closed until<br/>${nextDay} ${time} UK time`
        }
        document.querySelectorAll('span[opening-times]').forEach((el)=>{
            el.innerHTML = openingTimes
        })
        setTimeout(updateOpeningTimes, (60-now.getSeconds())*1000 + 500)
    }
    console.warn('schedule?')
    updateOpeningTimes()
    console.warn('phones')
    adjustPhoneNumbers()
    console.warn('currency')
    sa.setCurrency(sa.info.currency_code)
    console.warn('maps')
    const weatherMap = document.querySelector('#weather-map')
    if(weatherMap){
        doMap({container:weatherMap, type:'weather'})
    }
    sa.getMaps().forEach(doMap)
    sa.csrf();
    console.warn('newsletter')
    // newsletter
    if(document.querySelector('#footer-newsletter-signup')){
        sa.registerVueApp('#footer-newsletter-signup', {
            computed:{
                canSubmit(){
                    return !!this.first_name && !!this.email && this.email.match(/^.+@.+\..+$/)
                }
            },
            methods:{
                reset(){
                    this.$refs.form.reset()
                },
                submit(){
                    this.message = null
                    const _this = this
                    sa.submit(this.$refs.form, {first_name: this.first_name, email: this.email})
                        .then(function(r){
                            _this.first_name=''
                            _this.email=''
                            _this.message = 'Thank you. keep an eye on your inbox...'
                            _this.reset()
                        }).catch(function(e){
                            console.error(e)
                            _this.message = 'Sorry we could not sign you up.'
                        })
                }
            },
            data(){
                return {
                    message:null,
                    first_name:'',
                    email:'',
                };
            }
        })
    }
    // portal
    console.warn('portal')
    if(document.querySelector('#portal')){
        let stripe = null
        let stripeElements = null
        var stripeTag = document.createElement('script');
        stripeTag.src = 'https://js.stripe.com/v3/';
        document.body.append(stripeTag);
        sa.registerVueApp('#portal', {
            computed:{
                nationalityCountries(){
                    return window.utilities.countries
                },
                canSubmit(){
                    return !!this.email && this.email.match(/^.+@.+\..+$/)
                },
                canSubmitPassword(){
                    return !!this.password && this.password == this.password_confirmation
                },
                isLoggedIn(){
                    return !!this.sa_data
                },
                needsPassword(){
                    return this.sa_data.needs_password
                },
                needsSaving:{
                    cache:false,
                    get(){
                        let current = this.currentPaxCheck
                        let original = this.currentPaxOriginal
                        return original !== null && current != original
                    }
                },
                paxNumber(){
                    if(this.currentPax){
                        return this.currentBooking.pax_data.findIndex((p)=>p.id==this.currentPax.id) + 1
                    }
                    return false
                }
            },
            methods:{
                capitalizeAddress(inputField) {
                    let inputValue = inputField.value;
                    let words = inputValue.split(' ');
                    let capitalizedWords = [];

                    for (let i = 0; i < words.length; i++) {
                        let word = words[i];
                        if (word.length > 0) {
                            capitalizedWords.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
                        }
                        if (i < words.length - 1) {
                            capitalizedWords.push(' ');
                        }
                    }

                    inputField.value = capitalizedWords.join('');
                },
                async stripePayIntent(){
                    const {error} = await stripe.confirmPayment({
                        //`Elements` instance that was used to create the Payment Element
                        elements:stripeElements,
                        confirmParams: {
                            return_url: 'https://'+document.location.hostname+document.location.pathname,
                        },
                    });

                    if (error) {
                        this.stripeError = error.message;
                    } else {
                        // Your customer will be redirected to your `return_url`. For some payment
                        // methods like iDEAL, your customer will be redirected to an intermediate
                        // site first to authorize the payment, then redirected to the `return_url`.
                    }
                },
                stripeCreateIntent(){
                    const _this = this
                    sa.submit(this.$refs.moniesForm, {
                        amount:1000,
                        currency:'GBP',
                        booking_id: this.currentBooking.booking_id,
                        customer_id: this.sa_data.customer_id,
                    }, false, this.errorHandler)
                        .then(function(r){
                            try{
                                _this.stripeClientSecret = r.client_secret
                                setTimeout(()=>{
                                    stripe = Stripe(r.pub_key);
                                    const options = {
                                        clientSecret: r.client_secret,
                                        // Fully customizable with appearance API.
                                        appearance: {/*...*/},
                                    };

                                    // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 3
                                    stripeElements = stripe.elements(options);

                                    // Create and mount the Payment Element
                                    const paymentElement = stripeElements.create('payment',{
                                        layout: {
                                            type: 'accordion',
                                            defaultCollapsed: false,
                                            radios: false,
                                            spacedAccordionItems: false
                                        },
                                        paymentMethodOrder:['bacs_debit','card','klarna','afterpay_clearpay',],
                                    });
                                    paymentElement.mount('#payment-element');
                                },100)
                            }catch(x){
                                console.error(x)
                            }
                        })
                },
                countryName(v){
                    if(v){
                        const c = window.utilities.countries.find(c=>c.code == v)
                        return c ? c.name : v
                    }
                    return null
                },
                useLeadAddress(pax, event){
                    if(event.target.checked){
                        this.currentPax.address_1 = 'SAME AS LEAD'
                        this.currentPax.address_2 = null
                        this.currentPax.address_3 = null
                        this.currentPax.city = null
                        this.currentPax.country = null
                    }else{
                        this.currentPax.address_1 = null
                    }
                },
                confirmTravelInsurance(pax, event){
                    if(event.target.checked){
                        this.currentPax.travel_insurance_confirmed_at = (new Date()).toISOString()
                    }else{
                        this.currentPax.travel_insurance_confirmed_at = null
                    }
                },
                confirmBookingConditions(pax, event){
                    if(event.target.checked){
                        this.currentPax.booking_conditions_confirmed_at = (new Date()).toISOString()
                    }else{
                        this.currentPax.booking_conditions_confirmed_at = null
                    }
                },
                showTab(t){
                    if(t!=this.currentTab){
                        this.currentTab = t
                        let url = window.location.origin + window.location.pathname
                        if(this.currentBooking){
                            url += '?booking='+this.currentBooking.booking_id
                            if(this.currentPax){
                                '&passenger='+this.currentPax.id
                            }
                        }
                        if(t != 'pax-details'){
                            url +='#'+t
                        }
                        history.pushState(null,'',url)
                        setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
                    }
                },
                errorHandler(e){
                    console.error(e)
                    if(e.status == 401){
                        this.logout()
                    }
                },
                nights(a, b){
                    return utilities.dates.differenceInCalendarDays(new Date(b), new Date(a))
                },
                isSameDay(a, b){
                    return a&&b ? utilities.dates.isSameDay(new Date(a),new Date(b)) : ''
                },
                dateOnly(v){
                    return v ? utilities.dates.format(utilities.dates.parseDate(v),'dd/MM/y') : ''
                },
                timeOnly(v){
                    return v ? utilities.dates.format(new Date(v),'HH:mm') : ''
                },
                dateAndTime(v){
                    return v ? utilities.dates.format(new Date(v),'dd/MM/y HH:mm') : ''
                },
                dateVerbose(v){
                    let f = v ? utilities.dates.format(new Date(v),'EEEE do MMMM y') : ''
                    f=f.replace(/ ([0-9]{1,2})([a-z]{1,2}) /, ' \$1<sup>\$2</sup> ')
                    return f
                },
                dateAndTimeVerbose(v){
                    let f = v ? utilities.dates.format(new Date(v),'EEEE do MMMM y \'at\' HH:mm') : ''
                    f=f.replace(/ ([0-9]{1,2})([a-z]{1,2}) /, ' \$1<sup>\$2</sup> ')
                    return f
                },
                showPax(p){
                    const _this = this
                    let nationality = p.nationality ? window.utilities.countries.find((c)=>c.code == p.nationality) : null
                    if(!p.hasOwnProperty('summer_promo')){
                        p.summer_promo = null
                    }
                    this.currentPax = p
                    this.searchNationality = nationality ? nationality.name : ''
                    this.currentPaxOriginal = JSON.stringify(p)
                    this.currentPaxCheck = JSON.stringify(p)
                    history.pushState(null,'',window.location.origin + window.location.pathname+'?booking='+this.currentBooking.booking_id+'&passenger='+p.id+(this.currentTab!='pax-details'?'#'+this.currentTab:''))
                    setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
                    if(p.passport_image_id){
                        sa.submit(undefined, {_action:'portal',_sub_action:'bookings/'+this.currentBooking.booking_id+'/customers/'+p.id+'/passport/'+p.passport_image_id}, undefined, this.errorHandler)
                            .then(function(r){
                                _this.imagePreview = URL.createObjectURL(r);
                                _this.currentImage = null
                            })
                    }else{
                        _this.imagePreview = null
                        _this.currentImage = null
                    }
                },
                submitPax(confirmAndLock){
                    const _this = this
                    if(confirmAndLock){
                        if(!confirm('Once confirmed this passenger\'s details will be locked.\nAre you sure?')){
                            return
                        }
                    }else{
                        if(!confirm('Important: please complete as soon as possible as we cannot progress until you have done this.')){
                            return
                        }
                    }
                    let data = Object.assign({},this.currentPax,{confirmed_at:confirmAndLock ? (new Date()).toISOString():null})
                    sa.submit(this.$refs.paxForm, data, this.currentImage ? {passport_image:this.currentImage}:false, this.errorHandler)
                        .then(function(r){
                            try{
                                if(r.status == 'ok'){
                                    _this.showBooking(_this.currentBooking.booking_id)
                                }else if(r.hasOwnProperty('message')){
                                    if(r.message == 'email_in_use'){
                                        alert('This email address is already in use - please leave the field blank if no alternative email is used.');
                                    }
                                }
                            }catch(x){
                            }
                        })
                },
                closePax(){
                    this.currentPax = null
                    this.currentPaxOriginal = null
                    this.currentPaxCheck = null
                    history.pushState(null,'',window.location.origin + window.location.pathname+'?booking='+this.currentBooking.booking_id+(this.currentTab!='pax-details'?'#'+this.currentTab:''))
                    setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
                },
                showBooking(booking_id, cb){
                    this.currentPax = null
                    this.currentPaxOriginal = null
                    this.currentPaxCheck = null
                    history.pushState(null,'',window.location.origin + window.location.pathname+'?booking='+booking_id+(this.currentTab!='pax-details'?'#'+this.currentTab:''))
                    setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
                    const _this = this
                    sa.submit(undefined, {_action:'portal',_sub_action:'bookings/'+booking_id}, undefined, this.errorHandler)
                        .then(function(r){
                            r.pax_data.sort((a,b)=>{ return a.lead ? -1 : b.lead ? 1 : (a.first_name||"").localeCompare((b.first_name || ""))})
                            r.data.itinerary.hotels = {}
                            const hotels = r.data.itinerary.days.map((d)=> d.lines.filter((l=>l.type=='hotel')))
                            const expandedDays = r.data.itinerary.days.map((d)=> false)
                            if(expandedDays.length){expandedDays[0] = true}
                            for(let i = 0; i < hotels.length; i++){
                                for(let j = 0; j < hotels[i].length; j++){
                                    const h = hotels[i][j]
                                    let checkOut = new Date(h.data.check_out)
                                    for(let date = new Date(h.data.check_in); utilities.dates.isBefore(date, checkOut); date = utilities.dates.add(date,{days:1})){
                                        const dateKey = utilities.dates.format(date,'Y-MM-dd')
                                        if(!r.data.itinerary.hotels.hasOwnProperty(dateKey)){
                                            r.data.itinerary.hotels[dateKey] = []
                                        }
                                        r.data.itinerary.hotels[dateKey].push(h)
                                    }
                                }
                            }
                            _this.expandedDays = expandedDays
                            _this.currentBooking=r
                            cb && cb()
                        })
                },
                closeBooking(){
                    this.currentTab = 'pax-details'
                    this.currentPax = null
                    this.currentBooking = null
                    history.pushState(null,'',window.location.origin + window.location.pathname)
                    setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
                },
                updatePassword(){
                    const _this = this
                    sa.submit(undefined, {_action:'portal',_sub_action:'password', password: this.password, password_confirmation: this.password_confirmation}, undefined, this.errorHandler)
                        .then(function(r){
                            localStorage.setItem('sa_data',JSON.stringify(r))
                            _this.sa_data=r
                            if(r && r.bookings.length > 0){
                                _this.showBooking(r.bookings[0].booking_id)
                            }
                        })
                },
                reset(){
                    this.$refs.form.reset()
                },
                logout(){
                    history.pushState(null,'',window.location.origin + window.location.pathname)
                    setTimeout(()=>{document.scrollingElement.scrollTop = 0},0)
                    document.body.classList.remove('signed-in')
                    localStorage.removeItem('sa_data')
                    this.currentPax = null
                    this.currentPaxOriginal = null
                    this.currentPaxCheck = null
                    this.currentBooking = null
                    this.sa_data=null
                    this.status = null
                    this.password=''
                    this.email=''
                    this.loginMode = 'unknown'
                    sa.submit(undefined, {_action: 'portal', _sub_action:'logout'})
                    this.ready = true
                },
                login(){
                    const _this = this
                    sa.submit(this.$refs.form, {email: this.email, password:this.loginMode=='reset' ? null : this.password, reset:this.loginMode=='reset'}, undefined, (e)=>{if(e.status == 401){_this.status = "login failed"}})
                        .then(function(r){
                            if(r.hasOwnProperty('magic')){
                                _this.status = "magic link sent"
                            }else if(r.hasOwnProperty('reset')){
                                _this.status = "reset link sent"
                            }else if(r.hasOwnProperty('needs_password')){
                                history.replaceState(null,'',window.location.origin + window.location.pathname)
                                localStorage.setItem('sa_data',JSON.stringify(r))
                                _this.sa_data=r
                                if(r && r.bookings.length > 0){
                                    _this.showBooking(r.bookings[0].booking_id)
                                }
                            }else if(_this.loginMode != 'first'){
                                _this.status = "magic link sent"
                            }
                        })
                },
                magicLogin(token){
                    const _this = this
                    sa.submit(undefined, {_action:'portal',_sub_action:'login',token}, undefined, this.errorHandler)
                        .then(function(r){
                            history.replaceState(null,'',window.location.origin + window.location.pathname)
                            localStorage.setItem('sa_data',JSON.stringify(r))
                            _this.sa_data=r
                            if(r && r.bookings.length > 0){
                                _this.showBooking(r.bookings[0].booking_id)
                            }
                        })
                },
                handleNavigation(e){
                    if(!this.needsSaving){
                        this.ready = false
                        let booking = sa.getParam('booking')
                        const pax = sa.getParam('passenger')
                        if(!booking && this.sa_data && this.sa_data.bookings.length > 0){
                            booking = this.sa_data.bookings[0].booking_id
                        }
                        if(booking){
                            const _this = this
                            this.showBooking(booking, ()=>{
                                if(pax){
                                    _this.showPax(_this.currentBooking.pax_data.find((p)=>p.id==pax))
                                }
                                _this.ready = true
                            })
                        }else{
                            this.ready = true
                        }
                    }else if(e){
                        e.preventDefault()
                        return false
                    }
                },
                selectImage() {
                    /* Utility function to convert a canvas to a BLOB */
                    var dataURLToBlob = function(dataURL) {
                        var BASE64_MARKER = ';base64,';
                        if (dataURL.indexOf(BASE64_MARKER) == -1) {
                            var parts = dataURL.split(',');
                            var contentType = parts[0].split(':')[1];
                            var raw = parts[1];

                            return new Blob([raw], {type: contentType});
                        }

                        var parts = dataURL.split(BASE64_MARKER);
                        var contentType = parts[0].split(':')[1];
                        var raw = window.atob(parts[1]);
                        var rawLength = raw.length;

                        var uInt8Array = new Uint8Array(rawLength);

                        for (var i = 0; i < rawLength; ++i) {
                            uInt8Array[i] = raw.charCodeAt(i);
                        }

                        return new Blob([uInt8Array], {type: contentType});
                    }
                    /* End Utility function to convert a canvas to a BLOB      */
                    if(this.fileInput.files.length){
                        let file = this.fileInput.files.item(0);
                        const _this = this
                        if(file.type.match(/image.*/)) {

                            // Load the image
                            var reader = new FileReader();
                            reader.onload = function (readerEvent) {
                                var image = new Image();
                                image.onload = function (imageEvent) {

                                    // Resize the image
                                    var canvas = document.createElement('canvas'),
                                        max_size = 2000,
                                        width = image.width,
                                        height = image.height;
                                    if (width > height) {
                                        if (width > max_size) {
                                            height *= max_size / width;
                                            width = max_size;
                                        }
                                    } else {
                                        if (height > max_size) {
                                            width *= max_size / height;
                                            height = max_size;
                                        }
                                    }
                                    canvas.width = width;
                                    canvas.height = height;
                                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                                    var dataUrl = canvas.toDataURL('image/jpeg', 0.75);
                                    var resizedImage = dataURLToBlob(dataUrl);
                                    _this.imagePreview = URL.createObjectURL(resizedImage);
                                    _this.currentImage = resizedImage
                                }
                                image.src = readerEvent.target.result;
                            }
                            reader.readAsDataURL(file);
                        }
                    }
                },
                removeImage(){
                    this.currentPax.passport_image_id = null
                    this.currentImage = null;
                    this.imagePreview = null
                }
            },
            watch: {
                currentPax: {
                    handler(newValue, oldValue) {
                        if(newValue){
                            this.currentPaxCheck = JSON.stringify(newValue)
                        }
                    },
                    deep: true
                }
            },
            mounted(){
                if(document.location.hash == '#sign-out'){
                    this.logout()
                }else{
                    addEventListener('popstate', this.handleNavigation);
                    const token = sa.getParam('magic')
                    if(token){
                        this.magicLogin(token)
                    }
                    this.handleNavigation()
                }
            },
            data(){
                let sad = null
                try{
                    const _this = this
                    sad = JSON.parse(localStorage.getItem('sa_data')|| 'null')
                }catch(x){
                    
                }
                let loginMode = 'unknown'
                if(document.location.hash == '#register'){
                    loginMode = 'first'
                    document.location.hash = ''
                }else if(document.location.hash == '#sign-in'){
                    loginMode = 'normal'
                    document.location.hash = ''
                }else if(document.location.hash == '#reset'){
                    loginMode = 'reset'
                    document.location.hash = ''
                }
                return {
                    beta:/(^\?|&)test($|&)/.test(document.location.search),
                    stripeError:null,
                    stripeClientSecret:null,
                    searchNationality:'',
                    now: new Date(),
                    expandedDays:[],
                    loginMode:loginMode,
                    fileInput:null,
                    currentImage:null,
                    imagePreview:null,
                    ready:false,
                    currentTab:document.location.hash ? document.location.hash.replace(/^#/,''):'pax-details',
                    status:null,
                    currentPax:null,
                    currentPaxCheck:null,
                    currentPaxOriginal:null,
                    currentBooking:null,
                    password:'',
                    password_confirmation:'',
                    sa_data:sad,
                    email:'',
                };
            }
        })
    }
    console.warn('vues')
    const _vues = sa.getVues()
    for(var selector in _vues){
        try{
            window.createApp(_vues[selector]).mount(selector)
        }catch(x){
            console.error(x)
        }
    }
    console.warn('forms')
    document.querySelectorAll('.form-wrapper').forEach((fw)=>{
        const code = fw.querySelector('input[type="hidden"][name="_action"]').value
        fw.id = 'form-'+code
        const pages = []
        fw.querySelectorAll('.form-page').forEach((page)=>{
            pages.push({
                id:page.dataset.id,
                title:page.dataset.title,
                next_text:page.dataset.nextText,
            })
        })
        var app = {
            computed:{
                currentPageIndex(){
                    return this.pages.findIndex((p)=>p.id == this.currentPageId)
                },
                currentPage(){
                    return this.pages.find((p)=>p.id == this.currentPageId)
                },
            },
            mounted(){
                try{
                    const savedState = JSON.parse(localStorage.getItem(code))
                    if(savedState && this.$refs.form){
                        this.$refs.form.querySelectorAll('input:not([type="hidden"]),textarea').forEach((input)=>{
                            if(savedState.hasOwnProperty(input.name)){
                                if(input.type == 'radio'){
                                    try{
                                        this.$refs.form.querySelector('input[type="radio"][name="'+input.name+'"][value="'+savedState[input.name]+'"]').checked = true
                                    }catch(x){
                                    }
                                }else{
                                    input.value = savedState[input.name]
                                }
                            }
                        })
                    }
                }catch(x){
                    console.error(x)
                }
                document.addEventListener('visibilitychange', this.saveState)
            },
            methods:{
                saveState(){
                    if (document.visibilityState == 'hidden' && this.currentPageId != 'success') {
                        localStorage.setItem(code, JSON.stringify(sa.getFormData(this.$refs.form).data))
                        localStorage.setItem(code+'-page',this.currentPageIndex)
                    }
                },
                previous(){
                    if(this.currentPageIndex > 0){
                        this.currentPageId = pages[this.currentPageIndex-1].id
                        try{window.toTop()}catch(x){}
                    }
                },
                next(){
                    const errors = []
                    const page = document.querySelector('.form-page[data-id="'+this.currentPageId+'"]')
                    page.querySelectorAll('input,textarea').forEach((input)=>{
                        if(!input.validity.valid){
                            errors.push(input)
                        }
                    })
                    if(errors.length){
                        return
                    }
                    if(this.currentPageIndex < pages.length-1){
                        if(pages[this.currentPageIndex+1].id == 'success'){
                            this.submit()
                        }else{
                            this.currentPageId = pages[this.currentPageIndex+1].id
                        }
                        window.scrollTo(0,0)
                        try{window.toTop()}catch(x){}
                    }
                },
                submit:function(){
                    const _this = this
                    sa.submit(this.$refs.form)
                        .then(function(r){
                            _this.currentPageId = 'success'
                            localStorage.removeItem(code+'-page')
                            localStorage.removeItem(code)
                            _this.$refs.form.querySelectorAll('input,textarea').forEach((input)=>{
                                if(input.type == 'radio'){
                                    try{
                                        _this.$refs.form.querySelector('input[type="radio"][name="'+input.name+'"]:checked').checked = false
                                    }catch(x){
                                    }
                                }else{
                                    input.value = ''
                                }
                            })
                            _this.$refs.form.reset()
                            try{window.toTop()}catch(x){}
                            // document.location.href = this.$refs.form.dataset.redirect
                        }).catch(function(e){
                            console.error(e)
                            alert('an error occured, sorry')
                        })
                }
            },
            data() {
                window.x=this
                return {
                    pages,
                    currentPageId:pages[localStorage.getItem(code+'-page')||0].id
                }
            }
        }
        window.createApp(app).mount('#'+fw.id)
    })
    // Desktop navigation
    console.warn('desktop nav')
    let currentNavPath = null
    //const appElement = document.querySelector('#app')
    const navTopBar = document.querySelector('#nav-top-bar')
    const navMainBar = document.querySelector('#nav-main-bar')
    const navOverlay = document.querySelector('#nav-overlay')
    const navOverlayContent = document.querySelector('#nav-overlay-content') 
    if(navOverlay){
        navOverlay.addEventListener(clickEvent,(e)=>{toggleNav()})
    }
    function toggleNav(navPath){
        navPath = (!navPath || navPath == '#main-menu:close') ? null : navPath.replace('#main-menu:','')
        let next = ()=>{}
        let delay = 0
        if(currentNavPath == navPath || !navPath){
        // close
            navOverlayContent.classList.remove('translate-y-0')
            navOverlay.classList.remove('opacity-100')
            next = ()=>{
                //appElement.classList.remove('max-h-screen')
                navOverlay.classList.add('hidden')
                navOverlay.querySelectorAll('[data-nav-path]').forEach((e)=>{e.classList.add('hidden')})
                navTopBar.classList.remove('sticky','top-0')
                navMainBar.classList.remove('top-8')
            }
            currentNavPath = null
            delay = 150
        }else{
        // open
            currentNavPath = navPath
            navOverlay.querySelectorAll('[data-nav-path]:not([data-nav-path="'+navPath+'"])').forEach((e)=>{e.classList.add('hidden')})
            navOverlay.querySelector('[data-nav-path="'+navPath+'"]').classList.remove('hidden')
            navOverlay.classList.remove('hidden')
            //appElement.classList.add('max-h-screen')
            next = ()=>{
                navOverlayContent.classList.add('translate-y-0')
                navOverlay.classList.add('opacity-100')
                navTopBar.classList.add('sticky','top-0')
                navMainBar.classList.add('top-8')
            }
        }
        setTimeout(next, delay)
    }
    document.querySelectorAll('a[href^="#main-menu"]').forEach((el)=>{
        el.addEventListener(clickEvent,(e)=>{
            e.preventDefault()
            console.warn(' - '+el.getAttribute('href'))
            toggleNav(el.getAttribute('href'))
            return false
        })
    })

    // Mobile navigation
    console.warn('mobile nav')
    const mobileNavOverlay = document.querySelector('#mobile-nav-overlay')
    function toggleMobileNav(navPath){
        if(navPath == '#mobile-menu'){
            let show = mobileNavOverlay.classList.contains('hidden')
            let next = ()=>{}
            let delay = 0
            if(show){
                // open
                mobileNavOverlay.classList.remove('hidden')
                next = ()=>{
                    mobileNavOverlay.classList.add('opacity-100')
                }
            }
            setTimeout(next, delay)
        }else if(navPath == '#mobile-menu:close'){
            let show = mobileNavOverlay.classList.contains('hidden')
            let next = ()=>{}
            let delay = 0
            if(!show){
                // close
                mobileNavOverlay.classList.remove('opacity-100')
                next = ()=>{
                    //appElement.classList.remove('max-h-screen')
                    mobileNavOverlay.classList.add('hidden')
                }
                delay = 150
            }
            setTimeout(next, delay)
        }else{
            navPath = navPath.replace('#mobile-menu:','')
            let next = ()=>{}
            let delay = 0
            mobileNavOverlay.querySelectorAll('[data-mobile-nav-path]:not([data-mobile-nav-path="'+navPath+'"])').forEach((e)=>{e.classList.add('hidden')})
            mobileNavOverlay.querySelectorAll('[data-mobile-nav-path="'+navPath+'"]').forEach((e)=>{e.classList.remove('hidden')})
            next = ()=>{
            }
            setTimeout(next, delay)
        }
    }
    document.querySelectorAll('a[href^="#mobile-menu"]').forEach((el)=>{
        el.addEventListener(clickEvent,(e)=>{
            console.warn(' - '+el.getAttribute('href'))
            e.preventDefault()
            toggleMobileNav(el.getAttribute('href'))
            return false
        })
    })

    // Sliders
    console.warn('sliders')
    const sliders = new Map()
    document.querySelectorAll(`[data-goto-slide="1"]`).forEach((el)=>{
        el.classList.add('gallery-current')
    })
    document.querySelectorAll('[data-goto-slide]').forEach((el)=>{
        el.addEventListener(clickEvent,(e)=>{
            e.preventDefault()
            const swiper = sliders.get(el.dataset.sliderId)
            if(swiper){
                swiper.slideTo(el.dataset.gotoSlide)
            }
            return false
        })
    })
    document.querySelectorAll('.swiper').forEach((swiperElement)=>{
        const id = swiperElement.id
        const swiper = new Swiper(swiperElement, {
            loop: true,
            preloadImages: false,
            lazy: {enabled:true, checkInView:true,loadPrevNext:true},
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
        sliders.set(id, swiper)
        swiper.on('slideChange', function (e) {
            let el = document.querySelector(`[data-slider-id="${id}"][data-goto-slide].gallery-current`)
            if(el){
                el.classList.remove('gallery-current')
            }
            el = document.querySelector(`[data-slider-id="${id}"][data-goto-slide="${e.realIndex+1}"]`)
            if(el){
                el.classList.add('gallery-current')
            }
        });
    })
    function openDropdown(el){
        const dropdown = el.parentElement.querySelector('.dropdown') || el.closest('.dropdown')
        if( dropdown.classList.contains('hidden')){
            dropdown.classList.remove('hidden')
            function bind(){
                function closeDropdown(){
                    setTimeout(function(){
                        dropdown.classList.add('hidden')
                        window.removeEventListener(clickEvent, closeDropdown, false)
                    },50)
                }
                window.addEventListener(clickEvent, closeDropdown, false)
            }
            setTimeout(bind,0)
        }
    }
    console.warn('dropdowns')
    document.querySelectorAll('.dropdown-trigger').forEach((el)=>{
        el.addEventListener(clickEvent,(e)=>{
            e.preventDefault()
            openDropdown(el)
            return false
        })
    })

    // Appear on scroll
    console.warn('transitions')
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const xe = entry
                setTimeout(()=>{xe.target.classList.add('appear-on-scroll-on')}, 100)                
            }
        })
    })
    document.querySelectorAll('.appear-on-scroll').forEach((e)=>{
        observer.observe(e)
    })

    // Sub nav teleportation
    console.warn('teleport')
    const subnavIntersectionObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if(entry.isIntersecting){
            document.querySelectorAll('.sub-nav-item').forEach((e)=>{
                e.classList.add('hidden');
            })
            document.querySelectorAll('.main-nav-item').forEach((e)=>{
                e.classList.remove('hidden');
            })
        }else{
            document.querySelectorAll('.main-nav-item').forEach((e)=>{
                e.classList.add('hidden');
            })
            document.querySelectorAll('.sub-nav-item').forEach((e)=>{
                e.classList.remove('hidden');
            })
        }
    })
    })
    document.querySelectorAll('#sub-nav').forEach((e)=>{subnavIntersectionObserver.observe(e)});

    console.warn('autofit');
    (function(){
        document.querySelectorAll('.autofit h3,.autofit h2').forEach((e)=>{
            e.innerHTML = '<span class="fit">'+e.innerHTML+'</span>'
        });
        var autoSize = function(el) {
            const minSize = el.dataset['autosizeMin'] || (el.closest('[data-autosize-min]') ? el.closest('[data-autosize-min]').dataset['autosizeMin']:'') || parseFloat(document.defaultView.getComputedStyle(el, '')['fontSize'])
            const maxSize = el.dataset['autosizeMax'] || (el.closest('[data-autosize-max]') ? el.closest('[data-autosize-max]').dataset['autosizeMax']:'') || 44
            var adjustSize = function() {
                const fontSize = parseFloat(document.defaultView.getComputedStyle(el, '')['fontSize'])
                const multiplier = el.parentElement.clientWidth / el.getBoundingClientRect().width
                const size = Math.floor(multiplier*fontSize)
                el.style.fontSize = Math.min(Math.max(size, minSize), maxSize) + 'px';
            };
            adjustSize();
            el.addEventListener('resize', debounce(null, adjustSize), false)
        };
        document.querySelectorAll('.fit').forEach(autoSize)
    })()
    console.warn('footer')
    const footerCTA = document.querySelector('#footer-cta')
    if(footerCTA){
        let el = footerCTA.previousElementSibling
        while(el && el.previousElementSibling && el.tagName != 'DIV' && el.tagName != 'ASIDE'){
            el = el.previousElementSibling
        }
        el.classList.add('mb-24')
    }
    console.warn('video')
    try{
        showMovingStill()
    }catch(x){
        console.error(x)
    }
    console.warn('search')
    enableSearch()
}
if ( document.readyState !== 'loading' ) {
    setTimeout(setup,250)
}else{
    window.addEventListener('DOMContentLoaded', ()=>{setTimeout(setup,250)}, false);
}